export const SEO_PAGES = {
  HOME: {
    title: "Kalyanawaran - Matrimonial Service",
    description:
      "Aims to provide a centralized platform where brides and grooms can meet and communicate with each other.",
    link: "https://www.kalyanawaran.com/",
  },
  QUICK_UPLOAD: {
    title: "Quick Upload - Kalyanawaran",
    description: "Quickly upload your profile details to Kalyanawaran.",
    link: "https://www.kalyanawaran.com/quick-upload",
  },
  CONTACT_US: {
    title: "Contact Us - Kalyanawaran",
    description: "Contact Kalyanawaran for any queries or support.",
    link: "https://www.kalyanawaran.com/contact-us",
  },
  ABOUT_US: {
    title: "About Us - Kalyanawaran",
    description: "Learn more about Kalyanawaran Matrimony services.",
    link: "https://www.kalyanawaran.com/about-us",
  },
  NAKSHATRA_RASHI: {
    title: "Nakshatra Rashi List - Kalyanawaran",
    description: "Check the list of Nakshatras and their corresponding Rashis.",
    link: "https://www.kalyanawaran.com/nakshatra-rashi-list",
  },
  FORGET_PASSWORD: {
    title: "Forget Password - Kalyanawaran",
    description: "Recover your Kalyanawaran account password.",
    link: "https://www.kalyanawaran.com/forgetpassword",
  },
  LOGIN: {
    title: "Login - Kalyanawaran",
    description:
      "Login to your Kalyanawaran account to find your life partner.",
    link: "https://www.kalyanawaran.com/login",
  },
  REGISTER: {
    title: "Register - Kalyanawaran",
    description:
      "Register to find your perfect match. Join Kalyanawaran today!",
    link: "https://www.kalyanawaran.com/register",
  },
  GOTRALU: {
    title: "Arya Vysya Gotralu - Kalyanawaran",
    description: "Lineages of the 102 Rishis - Arya Vysya Gotralu",
    link: "https://www.kalyanawaran.com/gotralu",
  },
  PRIVACY_POLICY: {
    title: "Privacy Policy - Kalyanawaran",
    description: "Read the Privacy Policy of Kalyanawaran Matrimony.",
    link: "https://www.kalyanawaran.com/privacy-policy",
  },
  TERMS: {
    title: "Terms and Conditions - Kalyanawaran",
    description: "Read the Terms and Conditions of membership in Kalyanawaran.",
    link: "https://www.kalyanawaran.com/terms",
  },
  COOKIE_POLICY: {
    title: "Cookie Policy - Kalyanawaran",
    description: "Read the Cookie Policy of Kalyanawaran Matrimony.",
    link: "https://www.kalyanawaran.com/cookie-policy",
  },
  MEMBERS_PAGE: {
    title: "Members Details - Kalyanawaran",
    description:
      "View details of members looking for a life partner on Kalyanawaran Matrimony.",
    link: "https://www.kalyanawaran.com/members-pages",
  },
};
